<template>
  <div class="page">
    <!-- 标题：伪元素左侧竖线 -->
    <div class="page-title">问题反馈</div>

    <div class="form-card">
      <van-field
        v-model="form.opinion"
        type="textarea"
        rows="4"
        placeholder="请详细描述您遇到的问题"
      />

      <div class="upload-tip">上传图片/视频（最多5张）</div>
      <van-uploader v-model="form.images" :max-count="5"    :after-read="handleAutoUpload" multiple accept="image/*,video/*" />

   <div class="visit-item">
  <div class="visit-title">是否需要回访</div>
  <van-radio-group v-model="form.is_visit" direction="horizontal" style="margin: 10px 0;">
    <van-radio :name="true">需要</van-radio>
    <van-radio :name="false">不需要</van-radio>
  </van-radio-group>
</div>

      <van-field
        v-if="form.is_visit"
        v-model="form.phone"
        placeholder="请输入联系电话"
      />

      <div class="agree"   v-if="form.is_visit">

        <van-checkbox v-model="form.agree">已阅读并同意</van-checkbox><span @click="show=true">《用户授权协议》</span>
      </div>

      <van-button type="primary" block round @click="submit">
        提交反馈
      </van-button>
    </div>
<van-popup v-model="show" position="center" :style="{ height: '80%', width: '85%' }" closeable round>
  <div class="auth-container">
    <h2 class="auth-title">信息收集授权书</h2>
    <div class="auth-content">
      <p class="intro">
        为向您提供可靠的防伪查询服务，我们需要您授权我们收集和使用您的手机号码。请在使用本服务前，认真阅读并同意本授权书。
      </p>

      <div class="section">
        <h3>一、授权内容</h3>
        <p>您理解并同意，在您使用本防伪查询服务时，我们将收集并处理您主动填写的手机号码。</p>
      </div>

      <div class="section">
        <h3>二、使用目的与范围</h3>
        <p>我们收集您的手机号码，将严格用于以下目的：</p>
        <p>1、验证与安全保障：核验查询行为的真实性，防止系统被滥用，保障您的账户与服务安全。</p>
        <p>2、服务通知：向您发送本次查询的结果或与本次查询直接相关的必要通知。</p>
        <p>3、法定要求：为遵守法律法规规定所必需。</p>
        <p>我们承诺，未经您另行明确授权，不会将您的手机号码用于营销推广或提供给无关第三方。</p>
      </div>

      <div class="section">
        <h3>三、您的权利</h3>
        <p>您有权通过我们提供的客服渠道，查询、更正或要求删除您的手机号码信息，或撤回本授权。撤回授权后，我们将不再处理您的手机号码，但这不影响撤回前基于您的授权已进行的信息处理。</p>
      </div>

      <div class="section">
        <h3>四、授权生效</h3>
        <p>当您在服务界面点击 “同意” 或 “确认” 按钮时，即表示您已充分阅读、理解并接受本授权书的全部内容，本授权书即时生效。</p>
      </div>

      <div class="section">
        <h3>五、其他</h3>
        <p>您可以通过《隐私政策》了解我们关于个人信息处理的完整政策。如您不同意本授权书的任何条款，将可能无法使用本次防伪查询服务。</p>
      </div>
    </div>
  </div>
</van-popup>
  </div>
</template>

<script>
import http from "../common/http.js";

export default {
  name: 'userFeedback',
  data() {
    return {
      form:{
      opinion: '',
      phone: '',    
      agree: false,
      is_visit: false,
      images: []
      },
      show:false
    

  
    }
  },
  methods: {
   async submit() {
  
      let {opinion,phone,agree,images,is_visit}=this.form
     
       let arr =images.map(item=>item.url).filter(it=>it)
      if(!opinion){
        this.$toast('请填写问题描述')
        return
      }
      if(!phone && is_visit){
        this.$toast('请填写联系电话')
        return
      }
      if(!agree && is_visit){
        this.$toast('请阅读并同意协议')
        return
      }
      // if(arr<=0 ){
      //   this.$toast('请上传图片/视频,或等待上传完成')
      //   return
      // }
      let params={
        ...this.form,
        images:arr
      }
 
        let res= await http.post(`/goods/public/feedback`,params)
        this.$toast(res.message || '提交成功')
    },
    handleAutoUpload(file){

       if (Array.isArray(file)) {
        file.forEach(f => this.uploadSingleFile(f));
      } else {
       this.uploadSingleFile(file)
      }
    },
      async uploadSingleFile(fileObj,) {
            fileObj.status = 'uploading'
      try {
        const res = await http.newUploadOss(fileObj.file,'from', );
        fileObj.url = res;
            fileObj.status = 'done'
        this.$toast("上传成功");
        // setTimeout(() => {
        //   this.currentUploading = { prop: null, fileName: '', progress: 0 };
        // }, 300);
      } catch (error) {
            fileObj.status = 'failed'
        // this.formData[prop] = this.formData[prop].filter(item => item !== fileObj);
        // this.$toast.fail("上传失败，请重试");
        this.$toast("上传失败，请重试")
        this.form.images=this.form.images.filter(item => item !== fileObj)
        // this.currentUploading = { prop: null, fileName: '', progress: 0 };
      }
    },
  }
}
</script>

<style scoped>
/* 页面全局统一 */
.page {
  padding: 24px 16px;
  background: #f7f8fc;
  min-height: 100vh;
}

/* 标题 + 伪元素竖线（和所有页面完全统一） */
.page-title {
  position: relative;
  font-size: 20px;
  font-weight: 700;
  color: #1d2129;
  margin-bottom: 20px;
  padding-left: 12px;
  letter-spacing: 0.5px;
}
.page-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  background-color: #2E5CFA;
  border-radius: 2px;
}

/* 表单卡片 - 高级质感 */
.form-card {
  background: #fff;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 4px 18px rgba(0, 30, 120, 0.05);
}

/* 上传提示 */
.upload-tip {
  font-size: 13px;
  color: #8c92a3;
  margin: 22px 0 10px;
}

/* 协议 */
.agree {
  margin-top: 22px;
  font-size: 14px;
  color: #646c80;
  margin-bottom: 10px;
  display: flex;
}

/* 按钮统一美化 */
.el-button {
  height: 46px;
  font-size: 15px;
  border-radius: 12px;
  margin-top: 24px;
  font-weight: 500;
}
.el-button--primary {
  background-color: #2E5CFA;
  border-color: #2E5CFA;
}

.auth-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
  box-sizing: border-box;
}

.auth-title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.auth-content {
  flex: 1;
  overflow-y: auto; /* 超出内容可滚动 */
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.intro {
  margin-bottom: 6px;
  text-indent: 2em; /* 首行缩进 */
}

.section {
  margin-bottom: 6px;
}

.section h3 {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 2px;
}

.section p {
  margin: 0 0 6px 0;
  text-indent: 2em; /* 正文首行缩进 */
}
.visit-item {
  padding: 0 12px;
  margin: 15px 0;
}
.visit-title {
  font-size: 14px;
  color: #8c92a3;
  margin-bottom: 8px;
  font-weight: 500;
}
</style>